<template>
  <v-card elevation="0" class="rounded-lg pa-4 h-100">
    <v-row class="ma-0">
      <v-col cols="12">
        <span class="text-subtitle-1 font-weight-bold"> Custom Field </span>
      </v-col>
      <v-col
        cols="12"
        md="4"
        lg="3"
        v-for="(field, index) in fieldList"
        :key="index"
        :class="
          field.field_type == 'boolean_field' ? 'd-flex align-center' : ''
        "
      >
        <div v-if="field.field_type == 'boolean_field'">
          <SwitchField
            :id="field.name"
            v-model="customObject[field.name]"
            :name="field.name"
            inset
            true-value="true"
            false-value="false"
            :required="field.required"
            hide-details
            :label="field.label"
            :error-messages="customFieldsErrors[field.name]"
            @input="delete customFieldsErrors[field.name]"
          ></SwitchField>
        </div>
        <div
          v-if="
            field.field_type == 'char_field' ||
            field.field_type == 'text_field' ||
            field.field_type == 'email_field'
          "
        >
          <InputField
            :id="field.name"
            :required="field.required"
            v-model="customObject[field.name]"
            hide-details="auto"
            :prefix="field.prefix"
            :suffix="field.suffix"
            :rules="
              customObject[field.name]
                ? field.field_type == 'email_field'
                  ? [(v) => (v && emailValidation(v)) || 'Invalid email id']
                  : [
                      (val) =>
                        (val && nameValidation(val)) ||
                        'No special characters are allowed',
                    ]
                : []
            "
            :label="field.label"
            :name="field.name"
            :error-messages="customFieldsErrors[field.name]"
            @input="delete customFieldsErrors[field.name]"
          />
        </div>
        <div v-if="field.field_type == 'date_field'">
          <DatePicker
            type="date"
            :id="field.name"
            :required="field.required"
            v-model="customObject[field.name]"
            hide-details="auto"
            :label="`${field.label}${field.required ? ' *' : ''}`"
            outlined
            :name="field.name"
            :rules="
              field.required
                ? [(val) => !!val || `${field.label} is required`]
                : []
            "
            :error-messages="customFieldsErrors[field.name]"
            @input="delete customFieldsErrors[field.name]"
          />
        </div>
        <div v-if="field.field_type == 'date_time_field'">
          <DateTimeField
            fieldType="datetime"
            :id="field.name"
            v-model="customObject[field.name]"
            hide-details="auto"
            :inputProps="{
              label: `${field.label}${field.required ? ' *' : ''}`,
              required: field.required ? true : false,
              rules: field.required
                ? [(val) => !!val || `${field.label} is required`]
                : [],
              'error-messages': customFieldsErrors[field.name],
            }"
            outlined
            :name="field.name"
            @input="delete customFieldsErrors[field.name]"
          />
        </div>
        <div v-if="field.field_type == 'float_field'">
          <InputField
            :id="field.name"
            type="number"
            :name="field.name"
            :label="field.label"
            v-model="customObject[field.name]"
            :required="field.required"
            :prefix="field.prefix"
            :suffix="field.suffix"
            step="0.1"
            :rules="!!customObject[field.name] ? numberRule(field) : []"
            :error-messages="customFieldsErrors[field.name]"
            @input="delete customFieldsErrors[field.name]"
          />
        </div>
        <div
          v-if="
            field.field_type == 'integer_field' ||
            field.field_type == 'positive_integer_field'
          "
        >
          <InputField
            :id="field.name"
            type="number"
            :name="field.name"
            :label="field.label"
            v-model="customObject[field.name]"
            :required="field.required"
            :prefix="field.prefix"
            :suffix="field.suffix"
            step="1"
            :rules="!!customObject[field.name] ? numberRule(field) : []"
            :error-messages="customFieldsErrors[field.name]"
            @input="delete customFieldsErrors[field.name]"
          />
        </div>
        <div
          v-if="
            field.field_type == 'multi_select' || field.field_type == 'select'
          "
        >
          <SelectField
            :id="field.name"
            :menu-props="{ offsetY: true }"
            v-model="customObject[field.name]"
            :itemsList="field.choices"
            :name="field.name"
            :multiple="field.field_type == 'multi_select'"
            :label="`${field.label}${field.required ? ' *' : ''}`"
            :required="field.required"
            :rules="
              field.required
                ? [(v) => (!!v && v.length > 0) || `${field.label} is required`]
                : []
            "
            :error-messages="customFieldsErrors[field.name]"
            @input="delete customFieldsErrors[field.name]"
          />
        </div>
        <div v-if="field.field_type == 'time_field'">
          <InputField
            :id="field.name"
            type="time"
            :name="field.name"
            :label="field.label"
            v-model="customObject[field.name]"
            :required="field.required"
            :error-messages="customFieldsErrors[field.name]"
            @input="delete customFieldsErrors[field.name]"
          />
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { emailValidation } from "@/utils/functions.js";

export default {
  props: {
    fieldList: {
      type: Array,
      required: true,
    },
    formObject: {
      required: false,
    },
    fieldsErrors: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      emailValidation,
    };
  },
  computed: {
    customObject: {
      get() {
        return this.formObject;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    customFieldsErrors: {
      get() {
        return this.fieldsErrors;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    numberRule(field) {
      let rules = [];
      if (field.min_value != null || field.max_value != null) {
        let newRules = [
          (val) =>
            (field.min_value <= val && val <= field.max_value) ||
            `Value must be greater then ${field.min_value} OR value must be lesser ${field.max_value} are not allowed`,
        ];
        rules = [...rules, ...newRules];
      } else if (field.field_type == "positive_integer_field") {
        let newRules = [
          (val) =>
            (!!val && !val.match(/^[-+]?[0-9]+\.[0-9]+$/)) ||
            "Decimal value are not allowed",
          (val) => val > 0 || "Negative Numbers are not allowed",
        ];
        rules = [...rules, ...newRules];
      }
      return rules;
    },
    integerValidation(string) {
      let validRegex = /^-?\d*(\.\d+)?$/i;
      return validRegex.test(string);
    },
    nameValidation(string) {
      let validRegex = /^[a-zA-Z0-9_-]+$/i;
      return validRegex.test(string);
    },
  },
};
</script>
